<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <form @submit.prevent="savePumaPromoDetails">
                <h2>PLEASE ENTER PROMO DETAILS:</h2>
                <div class="col-md-3" style="padding-left:0;">
                    <strong>PROMO PACKAGE:</strong>
                    <admin-select v-model="packageType" required>
                        <option></option>
                        <option value="Black Package">Black Package</option>
                        <option value="New Product Package">New Product Package</option>
                    </admin-select>
                </div>
                <br>
                <div class="col-md-3" style="padding-left:0;">
                    <strong>PROMO DETAILS:</strong>
                    <admin-select v-model="packageDetails" required>
                        <option disabled value="">Select detail</option>
                        <option
                            v-for="(detail, index) in availablePromoDetails"
                            :key="index"
                            :value="detail.value"
                        >
                            {{ detail.label }}
                        </option>
                    </admin-select>
                </div>

                <br><br>
                <button class="btn-round-red" type="submit">NEXT STEP ></button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            activity: "",
            packageDetailsBlack: [
                { label: "PUMA - BLACK PACKAGE PROMO 5%", value: "PUMA - BLACK PACKAGE PROMO 5%|189764" },
                { label: "PUMA - BLACK PACKAGE PROMO 10%", value: "PUMA - BLACK PACKAGE PROMO 10%|189763" },
                { label: "PUMA - BLACK PACKAGE PROMO 15%", value: "PUMA - BLACK PACKAGE PROMO 15%|189762" },
                { label: "PUMA - BLACK PACKAGE PROMO 20%", value: "PUMA - BLACK PACKAGE PROMO 20%|189761" },
            ],
            packageDetailsNew: [
                { label: "PUMA - NEW PRODUCT PROMO 5%", value: "PUMA - NEW PRODUCT PROMO 5%|189760" },
                { label: "PUMA - NEW PRODUCT PROMO 10%", value: "PUMA - NEW PRODUCT PROMO 10%|189759" },
                { label: "PUMA - NEW PRODUCT PROMO 15%", value: "PUMA - NEW PRODUCT PROMO 15%|189758" },
                { label: "PUMA - NEW PRODUCT PROMO 20%", value: "PUMA - NEW PRODUCT PROMO 20%|189757" },
            ],
            packageDetails: "",
            packageType: "",
            submission: {},
        }
    },
    props: ['ppId'],
    created() {
        axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
            this.submission = response.data;
            this.activity = this.submission.activity.activity;

            if(this.submission.puma_promo) {
                this.packageType = this.submission.puma_promo.package_type;
                this.packageDetails = this.submission.puma_promo.package_details+"|"+this.submission.puma_promo.package_details_bt;
            }
        });
    },
    methods: {
        savePumaPromoDetails() {
            let data = {
                id: this.ppId,
                packageType: this.packageType,
                packageDetails: this.packageDetails,
            }
            axios.post(`/api/savePumaPromoDetails`, data).then(response => {
                this.$router.push({
                    name: "PumaPromoCompanySelect",
                    params: { ppId: this.ppId }
                });
            });
        }
    },
    computed: {
        availablePromoDetails() {
            if (this.packageType === "Black Package") {
                return this.packageDetailsBlack;
            } else if (this.packageType === "New Product Package") {
                return this.packageDetailsNew;
            } else {
                return [];
            }
        }
    },
    watch: {
        packageType(newVal) {
            this.promoDetail = "";
        }
    }
}
</script>
